import { 
    API_ENDPOINTS, 
    customToast, 
    FormInput, 
    replaceKeyWithValue, 
    route, 
    SelectOption, 
    Stepper, 
    useDisabledContext, 
    useLangContext, 
    useQueries, 
    Variants 
} from "carrier-fe";
import { ToshibaInstallationFormData } from "../../pages/installation/toshiba/journey";
import { UseFormReturn } from "../../types/journey";
import { PRODUCT_CHILDREN, QUERY_KEYS } from "../../util/Constants";
import { useEffect, useState } from "react";

type SelectKey = 'product_parents';
type Selects = Record<SelectKey, SelectOption[]>;

function ToshibaStep2({
    form,
    loading
}: {
    form: UseFormReturn<ToshibaInstallationFormData, any>,
    loading?: boolean,
}) {
    const { setValues, store, errors } = form;
    const { crud, fields } = useLangContext();
    const { disabled } = useDisabledContext();
    const [selects, setSelects] = useState<Selects>({
        product_parents: [],
    });

    const {
        data: selectOptions,
        error,
        isLoading
    } = useQueries<{ data: SelectOption[] }>([
        {
            key: QUERY_KEYS.PRODUCT_PARENTS,
            config: {
                method: 'GET',
                url: route(API_ENDPOINTS.GENERIC.SELECT.PRODUCT.PARENTS),
            },
        },
    ]);

    useEffect(() => {
        if (!selectOptions) return;

        setSelects((prev) => ({
            ...prev,
            product_parents: selectOptions?.product_parents?.data ?? []
        }))
    }, [selectOptions]);

    useEffect(() => {
        if (!error) return;

        Object.values(error).map((e) =>
            customToast({ 
                title: (e?.response?.data as any)?.message, 
                variant: Variants.Danger 
            })
        );
    }, [error]);

    return (
        <Stepper.Step
            loading={isLoading || loading}
            title={fields?.system_type
                || 'system type'
            }
        >
            <FormInput
                name='product_parent_id'
                type='searchable-select'
                label={replaceKeyWithValue(
                    crud?.sub_titles?.select
                        || 'Please select a :field',
                    'field',
                    fields?.system_type
                        || 'system type'
                )}
                disabled={disabled}
                options={selects.product_parents}
                value={store?.product_parent_id}
                onChange={(val) => {
                    if (typeof val !== 'string') return;

                    const productParentName = selects.product_parents.find(
                        productParent => productParent.value === val
                    )?.label;

                    setValues({
                        product_parent_id: val,
                        skip_step_5: productParentName === PRODUCT_CHILDREN.A2A
                    });
                }}
                errorMessages={errors?.product_parent_id}
                clearable={false}
            />
        </Stepper.Step>
    )
};

export default ToshibaStep2;